/**
 * Replace {{var}} placeholders in an email template with provided values.
 * Unknown placeholders are left untouched so the user can still see/fix them.
 */
export function fillTemplate(
  text: string,
  vars: Record<string, string | number | null | undefined>
): string {
  if (!text) return text;
  return text.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key: string) => {
    const v = vars[key];
    return v === undefined || v === null ? match : String(v);
  });
}
